import { gql } from '@/store/helpers/axios.js'

export default {
  async GET_MY_PROPERTIES ({ commit }) {
    const query = `query liegenschaften($order_by: LiegenschaftenUserSort) {
      liegenschaften(order_by: $order_by) {
        nodes {
          liegenschaftId
          strasse
          hausNr
          plz
          ort
          egid
          versicherungsNr
          parzellenNr
          gebaeudeart
          nutzung
          baujahr
          anzahlWohnungen
          energiebezugsflaeche
          hauptwaermeerzeugungBestehend
          hauptwaermeerzeugungBestehendAndereText
          hauptwaermeerzeugungNeu
          denkmalgeschuetzt
          adresse
          nutzungsartBezeichnung
          gebaeudeartBezeichnung
          gemeindeId
          createdUserEmail
        }
      }
    }`

    const variables = {
      order_by: {
        gebaeudeart: 'ASC',
        ort: 'ASC',
        strasse: 'ASC',
        hausNr: 'ASC'
      }
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
      commit('SET_PROPERTIES', data.data.liegenschaften.nodes)
    }

    return data
  },
  async GET_PROPERTY_BY_ID ({ commit }, { propertyId, includeOrganisation }) {
    const query = `query liegenschaftById($liegenschaftId: Int!, $includeOrganisation: Boolean!) {
      liegenschaftById(liegenschaftId: $liegenschaftId, includeOrganisation: $includeOrganisation) {
        liegenschaftId
        strasse
        hausNr
        plz
        ort
        egid
        versicherungsNr
        parzellenNr
        gebaeudeart
        nutzung
        baujahr
        anzahlWohnungen
        energiebezugsflaeche
        hauptwaermeerzeugungBestehend
        hauptwaermeerzeugungBestehendAndereText
        hauptwaermeerzeugungNeu
        denkmalgeschuetzt
        adresse
        nutzungsartBezeichnung
        gebaeudeartBezeichnung
        gemeindeId
        hauptwaermeerzeugungBestehendBezeichnung
        hauptwaermeerzeugungNeuBezeichnung
      }
    }`

    const variables = {
      liegenschaftId: Number(propertyId),
      includeOrganisation
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
      commit('SET_PROPERTY_BY_ID', data.data.liegenschaftById)
    }

    return data
  },
  async SAVE_PROPERTY ({ commit }, formData) {
    const {
      strasse,
      hausNr,
      plz,
      ort,
      egid,
      versicherungsNr,
      parzellenNr,
      gebaeudeart,
      denkmalgeschuetzt,
      energiebezugsflaeche,
      hauptwaermeerzeugungBestehend,
      hauptwaermeerzeugungNeu,
      nutzung,
      baujahr,
      anzahlWohnungen,
      hauptwaermeerzeugungBestehendAndereText,
      gemeindeId
    } = formData

    const query = `mutation liegenschaftCreate($input: LiegenschaftCreateInput!) {
      liegenschaftCreate(input: $input) {
        liegenschaftId
        strasse
        hausNr
        plz
        ort
        egid
        versicherungsNr
        parzellenNr
        gebaeudeart
        nutzung
        baujahr
        anzahlWohnungen
        energiebezugsflaeche
        hauptwaermeerzeugungBestehend
        hauptwaermeerzeugungBestehendAndereText
        hauptwaermeerzeugungNeu
        denkmalgeschuetzt
        gemeindeId
      }
    }`

    const strEnergiebezugsflaeche = `${energiebezugsflaeche}`
    const parsedEnergiebezugsflaeche = Number(strEnergiebezugsflaeche.replace(/'/g, ''))

    const variables = {
      input: {
        strasse,
        hausNr,
        plz,
        ort,
        egid,
        versicherungsNr,
        parzellenNr,
        gebaeudeart,
        denkmalgeschuetzt,
        energiebezugsflaeche: parsedEnergiebezugsflaeche,
        hauptwaermeerzeugungBestehend,
        hauptwaermeerzeugungNeu,
        nutzung,
        baujahr,
        anzahlWohnungen,
        hauptwaermeerzeugungBestehendAndereText,
        gemeindeId
      }
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
      const { liegenschaftCreate: property } = data.data
      commit('SET_PROPERTY', property)
      commit('application/SET_APPLICATION_PROPERTY_ID', property.liegenschaftId, { root: true })
      commit('application/SET_APPLICATION_COMMUNITY', property.gemeindeId, { root: true })
    }

    return data
  },
  async UPDATE_PROPERTY ({ commit }, formData) {
    const {
      liegenschaftId,
      strasse,
      hausNr,
      plz,
      ort,
      egid,
      versicherungsNr,
      parzellenNr,
      gebaeudeart,
      denkmalgeschuetzt,
      energiebezugsflaeche,
      hauptwaermeerzeugungBestehend,
      hauptwaermeerzeugungNeu,
      nutzung,
      baujahr,
      anzahlWohnungen,
      hauptwaermeerzeugungBestehendAndereText,
      gemeindeId
    } = formData

    const query = `mutation liegenschaftUpdate($input: LiegenschaftUpdateInput!) {
      liegenschaftUpdate(input: $input) {
        liegenschaftId
        strasse
        hausNr
        plz
        ort
        egid
        versicherungsNr
        parzellenNr
        gebaeudeart
        nutzung
        baujahr
        anzahlWohnungen
        energiebezugsflaeche
        hauptwaermeerzeugungBestehend
        hauptwaermeerzeugungBestehendAndereText
        hauptwaermeerzeugungNeu
        denkmalgeschuetzt
        nutzungsartBezeichnung
        gebaeudeartBezeichnung
        gemeindeId
      }
    }`

    const strEnergiebezugsflaeche = `${energiebezugsflaeche}`
    const parsedEnergiebezugsflaeche = Number(strEnergiebezugsflaeche.replace(/'/g, ''))

    const variables = {
      input: {
        liegenschaftId: Number(liegenschaftId),
        strasse,
        hausNr,
        plz,
        ort,
        egid,
        versicherungsNr,
        parzellenNr,
        gebaeudeart,
        denkmalgeschuetzt,
        energiebezugsflaeche: parsedEnergiebezugsflaeche,
        hauptwaermeerzeugungBestehend,
        hauptwaermeerzeugungNeu,
        nutzung,
        baujahr,
        anzahlWohnungen,
        hauptwaermeerzeugungBestehendAndereText,
        gemeindeId
      }
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
      commit('UPDATE_PROPERTY', data.data.liegenschaftUpdate)
    }

    return data
  },
  async DELETE_PROPERTY ({ commit }, propertyId) {
    const query = `mutation liegenschaftDelete($liegenschaftId: Int!) {
      liegenschaftDelete(liegenschaftId: $liegenschaftId) {
        ok
      }
    }`

    const variables = {
      liegenschaftId: propertyId
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
      commit('DELETE_PROPERTY', propertyId)
    }

    return data
  },
  async GET_IS_VALID_COMMUNITY ({ commit }, communityName) {
    const query = `query gemeinden ($where: GemeindeFilter) {
      gemeinden (where: $where) {
        id
        name
      }
    }`

    const variables = {
       where: {
         name: communityName
       }
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
      const { gemeinden } = data.data
      commit('SET_IS_VALID_COMMUNITY', !!gemeinden.length)
    }

    return data
  }
}
